var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function shouldBeOneOf(options) {
    return function (value) {
        var result = options.includes(value);
        if (!result) {
            console.error.apply(console, __spreadArray(['The value received was `', value, '`, but one of these were expected:\n'], options.map(function (item) { return "- ".concat(item, "\n"); }), false));
        }
        return result;
    };
}
export default shouldBeOneOf;
//# sourceMappingURL=shouldBeOneOf.js.map